import axios from 'axios';

/**
 * Service for fetching event detail data for ticket selection modal
 */
export const EventDetailService = {
  /**
   * Get complete event detail including ticket types, banner, assets
   * @param {number} eventId
   * @returns {Promise<Object>} Event detail data
   */
  async getEventDetail(eventId) {
    return axios.get(`/api/v2/tickets/events/${eventId}`);
  },
};
